const postEquipmentsStr = {
  toastr: 'Equipment added',
  toastr1: 'The equipment has been successfully added.',
  toastrError: 'Equipment already registered',
  toastrError1: 'Enter this CNPJ or Name already registered',
  toastrError2: 'Error creating Equipment',
  serialNumberError: 'There is already a device with the same serial number for this site',
  
};

export default postEquipmentsStr;
